import React from 'react'
const IconArrowBottom = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='12' cy='12' r='12' fill='white' />
      <path
        d='M7 10L12.2941 15L17 10'
        stroke='#242424'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default IconArrowBottom
